<template>
  <v-layout row>
    <v-flex xs1></v-flex>
    <v-flex xs3 class="mt-3 text-left">
      <h5 class="title font-weight-medium compress">Modify Configuration</h5>
      <h5 class="heading font-weight-thin">
        The configuration data listed to the right is used in the
        Sustaine&trade; guidance calculations. To modify a value, click the
        <v-icon small color="secondary">edit</v-icon>
        to open the edit dialog to modify that value.
      </h5>
    </v-flex>
    <v-flex xs1></v-flex>
    <v-flex xs4>
      <!-- edit dialog -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Configuration</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm7 md7 text-left>
                  <v-text-field
                    readonly
                    v-model="editedItem.configName"
                    style="border: 0;"
                    label=" Configuration Item (read only)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    autofocus
                    v-model="editedItem.configValue"
                    label="Value"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm1 md1> </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
            <v-btn color="primary" @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- data -->
      <v-data-table
        :headers="headers"
        :items="configs"
        hide-actions
        disable-initial-sort
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-right">{{ props.item.configName }}</td>
          <td class="text-left">
            {{ props.item.configValue }} {{ props.item.configUnit }}
          </td>
          <td class="text-left layout px-0">
            <v-btn
              icon
              outlined
              dark
              color="primary"
              small
              @click="editItem(props.item)"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
          <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs3></v-flex>
  </v-layout>
</template>

<script>
import MockDataService from '@/services/MockDataService'
export default {
  data: () => ({
    dialog: false,
    headers: [
      {
        text: 'Configuration Item',
        align: 'right',
        sortable: 'false',
        value: 'configName'
      },
      { text: 'Value', align: 'left', sortable: 'false', value: 'configValue' },
      { text: '', align: 'left', sortable: 'false', value: '' }
    ],
    configs: [],
    editedIndex: -1,
    editedItem: {
      configName: '',
      configValue: 0
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      let rawData = MockDataService.getFacilityConfiguration()
      this.configs.push({
        configUnit: 'minutes',
        configName: 'Minimum Runtime',
        configValue: parseInt(rawData.configuration.minRunTimeMinutes)
      })
      this.configs.push({
        configUnit: 'minutes',
        configName: 'Maximum Runtime',
        configValue: parseInt(rawData.configuration.maxRunTimeMinutes)
      })
      this.configs.push({
        configUnit: 'minutes',
        configName: 'Min Time Between Runs',
        configValue: parseInt(rawData.configuration.minTimeBetweenRuns)
      })
      this.configs.push({
        configUnit: 'minutes',
        configName: 'Ramp Up',
        configValue: parseInt(rawData.configuration.rampUpMinutes)
      })
      this.configs.push({
        configUnit: 'minutes',
        configName: 'Ramp Down',
        configValue: parseInt(rawData.configuration.rampDownMinutes)
      })
      let wkend =
        parseInt(rawData.configuration.runOnWeekends) === 0 ? 'No' : 'Yes'
      this.configs.push({
        configUnit: '',
        configName: 'Run on Weekends',
        configValue: wkend
      })
      this.configs.push({
        configUnit: '',
        configName: 'Maximum Starts',
        configValue: parseInt(rawData.configuration.maxStarts)
      })
      this.configs.push({
        configUnit: '%',
        configName: 'Threshold Above DA',
        configValue: parseInt(
          rawData.configuration.thresholdAboveDAFactor * 100.0
        )
      })
      this.configs.push({
        configUnit: '%',
        configName: 'Threshold Below DA',
        configValue: parseInt(
          rawData.configuration.thresholdBelowDAFactor * 100.0
        )
      })
      this.configs.push({
        configUnit: 'kW',
        configName: 'Maximum Output',
        configValue: parseInt(rawData.configuration.maxOutputKw)
      })
      this.configs.push({
        configUnit: '',
        configName: 'Hourly Run Cost',
        configValue: parseFloat(rawData.configuration.costToRunPerHour).toFixed(
          2
        )
      })
      this.configs.push({
        configUnit: '',
        configName: 'Startup Cost',
        configValue: parseFloat(rawData.configuration.startupCost).toFixed(2)
      })
      this.configs.push({
        configUnit: '',
        configName: 'Bid Price',
        configValue: parseFloat(
          rawData.configuration.comparisonRTBidPrice
        ).toFixed(2)
      })
    },

    editItem(item) {
      this.editedIndex = this.configs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.configs[this.editedIndex], this.editedItem)
      } else {
        this.configs.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
